import React from 'react';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip } from '@fortawesome/pro-solid-svg-icons';

import Ottercon from 'components/ottercon';
import Tooltip from 'components/tooltip';

import type { Task } from 'bundles/apex/tasks/types';

interface Props {
  task: Task;
  onClick?: () => void;
}

export default function AttachmentIcon({ task, onClick }: Props) {
  let content;
  if (task.attachments.length === 1) {
    const attachment = task.attachments[0];
    content = (
      <div className="d-flex">
        <Ottercon ottercon={attachment.ottercon} size="xs" />
        <div className="flex-1 one-line ml-2" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {attachment.displayName}
        </div>
      </div>
    );
  } else if (task.attachments.length > 0) {
    content = `${task.attachments.length} Attached`;
  } else if (task.attachmentExceptionReason) {
    content = (
      <Tooltip content={task.attachmentExceptionReason}>
        <span>0 Attached</span>
      </Tooltip>
    );
  } else {
    content = (
      <span
        className={classNames(
          'apex-tasks-list__attachments-placeholder',
          'ds-border',
          'ds-border-light',
          'ds-border-dashed',
          'ds-rounded',
          'p-2',
          'one-line',
        )}
      >
        <FontAwesomeIcon className="mt-1 mr-2" icon={faPaperclip} />
        Attach
      </span>
    );
  }

  return <>
    <div className="clickable" onClick={onClick}>
      {content}
    </div>
  </>;
}
